module.exports = __webpack_public_path__ + "img/topic-hero.024334f7.jpg";